import { apiGet, apiPut } from "./http";
import type { OrderStatus, RedemptionOrder } from "../pages/admin/utils/rewardsStore";

export interface RedemptionOrderApiRow {
  id: string;
  memberId: string;
  memberName: string;
  memberNo: string;
  rewardId: number;
  rewardName: string;
  rewardCover: string;
  pointsCost: number;
  createdAt: string;
  status: OrderStatus;
  trackingNo?: string | null;
  address?: string | null;
}

export function mapRedemptionOrderApi(row: RedemptionOrderApiRow): RedemptionOrder {
  return {
    id: row.id,
    memberId: row.memberId,
    memberName: row.memberName,
    memberNo: row.memberNo,
    rewardId: row.rewardId,
    rewardName: row.rewardName,
    rewardCover: row.rewardCover,
    pointsCost: row.pointsCost,
    createdAt: row.createdAt,
    status: row.status,
    trackingNo: row.trackingNo ?? undefined,
    address: row.address ?? undefined,
  };
}

export async function fetchTenantRedemptionOrders(
  tenantLegacyId: string,
  memberLegacyId?: string
): Promise<RedemptionOrder[]> {
  const q = memberLegacyId ? `?memberLegacyId=${encodeURIComponent(memberLegacyId)}` : "";
  const rows = await apiGet<RedemptionOrderApiRow[]>(`/api/tenants/${tenantLegacyId}/redemption-orders${q}`);
  return rows.map(mapRedemptionOrderApi);
}

export async function updateRedemptionOrderApi(
  tenantLegacyId: string,
  orderLegacyId: string,
  body: { status: "shipped" | "completed"; trackingNo?: string | null }
): Promise<RedemptionOrderApiRow> {
  return apiPut<RedemptionOrderApiRow>(
    `/api/tenants/${tenantLegacyId}/redemption-orders/${encodeURIComponent(orderLegacyId)}`,
    body
  );
}
